import { Alert, Empty, Spin } from 'antd'
import { usePackageStore } from '@/store/packageStore'

interface AppScopeGuardProps {
  children: React.ReactNode
  description?: string
}

export function AppScopeGuard({ children, description }: AppScopeGuardProps) {
  const appList = usePackageStore((state) => state.appList)
  const appListLoaded = usePackageStore((state) => state.appListLoaded)

  if (!appListLoaded) {
    return (
      <div style={{ padding: '72px 0', textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    )
  }

  if (appList.length === 0) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          type="warning"
          showIcon
          message="当前角色没有可访问包"
          description={description || '请联系超级管理员在角色权限配置中添加可选包。未配置包权限时，本页面不会加载任何包维度数据。'}
          style={{ marginBottom: 24 }}
        />
        <Empty description="无可访问包" />
      </div>
    )
  }

  return <>{children}</>
}
